export default function formatByteCount(bytes: number): string {
    const megaBytes = (bytes / (1024 * 1024)).toFixed(1);
    return `${megaBytes}MiB`;
}
